import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientReceivedDocument } from '../models/client-received-document.model';

// Listing/viewing/downloading stays routed through the chat feature's endpoints as documented
// below, but removal is now supported: `remove` reuses the exact same generic backend
// document-delete endpoint (`DELETE /api/organizations/{organizationId}/documents/{documentId}`)
// that `IPatientDocumentsRepository.remove` already uses, since the backend's `Document` deletion is
// keyed only by `Id` + `organizationId` regardless of whether the document originated from a chat
// attachment or a patient upload. Viewing/downloading a listed document still reuses the chat
// feature's shared attachment-download endpoint (`IChatRepository.downloadAttachment`) rather than a
// method on this interface, since both features hit the exact same backend route keyed by
// `Document.PublicId`.
export interface IClientDocumentsRepository {
  // `recipientClientId` is the `AppClient.Id` (a GUID) this client is linked to -- NOT this
  // feature's own `Client.id` (a ProVet external id). See `ClientDocumentsStore.load` for how that
  // id is resolved before calling this.
  list(organizationId: number, recipientClientId: string): Observable<readonly ClientReceivedDocument[]>;
  upload(organizationId: number, recipientClientId: string, file: File): Observable<ClientReceivedDocument>;
  remove(organizationId: number, documentId: number): Observable<void>;
}

export const CLIENT_DOCUMENTS_REPOSITORY =
  new InjectionToken<IClientDocumentsRepository>('IClientDocumentsRepository');
